import React, { useState } from "react";

const plans = [
  {
    icon:"🏥",
    title:"Health Insurance",
    description:"Hospital cash benefit for illness and injury. Covers hospitalization, ICU, and surgery costs.",
    price:"Rs 99",
    period:"/week",
    tag:"Most Popular",
    tagColor:"#0d9488",
    covers:[
      "✅ Rs 9,900 hospital cash/day (100x premium)",
      "✅ ICU benefit up to Rs 19,800/day",
      "✅ Surgery cover up to Rs 99,000",
      "✅ Ambulance charges covered",
      "✅ Pre & post hospitalization",
    ]
  },
  {
    icon:"🦺",
    title:"Personal Accident",
    description:"Covers accidental death, permanent disability and fractures. Essential for commuters and daily workers.",
    price:"Rs 149",
    period:"/week",
    tag:"",
    tagColor:"",
    covers:[
      "✅ Accidental death cover Rs 14,900 (100x)",
      "✅ Permanent disability Rs 14,900",
      "✅ Fracture benefit Rs 7,450",
      "✅ Hospital cash Rs 500/day",
      "✅ Ambulance cover included",
    ]
  },
  {
    icon:"✈️",
    title:"Domestic Travel",
    description:"Stay protected on every trip within Nepal. Covers delays, emergencies and accidents while travelling.",
    price:"Rs 199",
    period:"/week",
    tag:"",
    tagColor:"",
    covers:[
      "✅ Emergency medical Rs 19,900 (100x)",
      "✅ Trip delay compensation Rs 2,000",
      "✅ Accidental death Rs 19,900",
      "✅ Lost baggage Rs 5,000",
      "✅ 24/7 travel helpline",
    ]
  },
  {
    icon:"👨‍👩‍👧",
    title:"Family Floater",
    description:"One plan covers your entire family — spouse, kids and parents. Best value insurance for Nepali families.",
    price:"Rs 499",
    period:"/week",
    tag:"Best Value",
    tagColor:"#7c3aed",
    covers:[
      "✅ Covers up to 5 family members",
      "✅ Combined cover Rs 49,900 (100x)",
      "✅ Hospital cash for every member",
      "✅ Accidental death & disability",
      "✅ Children's accident benefit",
    ]
  },
  {
    icon:"📱",
    title:"Mobile Device",
    description:"Covers screen damage, theft and water damage. Requires a quick phone inspection at purchase.",
    price:"Rs 199",
    period:"/week",
    tag:"Inspection Required",
    tagColor:"#0891b2",
    covers:[
      "✅ Screen damage repair Rs 9,950 (50x)",
      "✅ Theft cover Rs 19,900 (100x)",
      "✅ Water damage covered",
      "✅ Phone inspection at signup",
      "✅ Same-day claim processing",
    ]
  },
  {
    icon:"👷",
    title:"Daily Wage Worker",
    description:"Nepal's first income protection plan for daily wage workers. Miss work due to injury? We pay your daily wage.",
    price:"Rs 99",
    period:"/week",
    tag:"Unique to Nepal",
    tagColor:"#ea580c",
    covers:[
      "✅ Income replacement Rs 500/day",
      "✅ Accidental death Rs 9,900 (100x)",
      "✅ Hospitalization cash benefit",
      "✅ Fracture & disability cover",
      "✅ No documents needed",
    ]
  },
  {
    icon:"🐄",
    title:"Livestock Insurance",
    description:"Protect your cow, buffalo or goat from death due to disease or accident. Built for Nepali farmers.",
    price:"Rs 199",
    period:"/week",
    tag:"For Farmers",
    tagColor:"#059669",
    covers:[
      "✅ Animal death cover Rs 19,900 (100x)",
      "✅ Veterinary expenses Rs 5,000",
      "✅ Disease & accident both covered",
      "✅ Covers cow, buffalo & goat",
      "✅ Photo of animal required at signup",
    ]
  },
  {
    icon:"🏢",
    title:"Intern Insurance",
    description:"Companies can instantly insure their interns. Perfect for startups, NGOs and corporates hiring short-term.",
    price:"Rs 149",
    period:"/week per intern",
    tag:"For Companies",
    tagColor:"#2563eb",
    covers:[
      "✅ Accidental death Rs 14,900 (100x)",
      "✅ Medical expense Rs 9,900",
      "✅ Disability benefit included",
      "✅ Certificate to company & intern",
      "✅ Bulk purchase available",
    ]
  },
];

function BuyModal({ plan, onClose }) {
  const [form, setForm] = useState({ name:"", phone:"", email:"", dob:"" });
  const [submitted, setSubmitted] = useState(false);
  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  return (
    <div style={{position:"fixed", top:0, left:0, width:"100%", height:"100%", background:"rgba(0,0,0,0.75)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:1000, backdropFilter:"blur(6px)"}}>
      <div style={{background:"#fff", border:"2px solid #e2e8f0", borderRadius:"24px", padding:"40px", width:"480px", position:"relative", boxShadow:"0 24px 64px rgba(0,0,0,0.2)", maxHeight:"90vh", overflowY:"auto"}}>
        <button onClick={onClose} style={{position:"absolute", top:"16px", right:"16px", background:"#f1f5f9", border:"none", color:"#374151", fontSize:"16px", cursor:"pointer", width:"32px", height:"32px", borderRadius:"999px"}}>✕</button>
        {!submitted ? (
          <>
            <div style={{marginBottom:"24px", paddingBottom:"20px", borderBottom:"1px solid #f1f5f9"}}>
              <span style={{fontSize:"40px"}}>{plan.icon}</span>
              <h2 style={{fontSize:"22px", fontWeight:"900", color:"#0f172a", margin:"8px 0 4px"}}>{plan.title}</h2>
              <div style={{display:"flex", alignItems:"center", gap:"8px", marginBottom:"12px"}}>
                <span style={{fontSize:"24px", fontWeight:"900", color:"#0d9488"}}>{plan.price}</span>
                <span style={{color:"#64748b", fontSize:"14px"}}>{plan.period}</span>
              </div>
              <div style={{background:"#f0fdfa", borderRadius:"12px", padding:"12px 16px"}}>
                {plan.covers.map((c, i) => (
                  <div key={i} style={{fontSize:"13px", color:"#0f172a", marginBottom:"4px", lineHeight:"1.6"}}>{c}</div>
                ))}
              </div>
              <div style={{marginTop:"10px", fontSize:"12px", color:"#64748b"}}>🤝 Underwritten by Himalayan Life Insurance</div>
            </div>
            <div style={{display:"flex", flexDirection:"column", gap:"14px"}}>
              {[
                {label:"Full Name", name:"name", placeholder:"Ram Bahadur Thapa", type:"text"},
                {label:"Phone Number", name:"phone", placeholder:"98XXXXXXXX", type:"tel"},
                {label:"Email Address", name:"email", placeholder:"ram@example.com", type:"email"},
                {label:"Date of Birth", name:"dob", placeholder:"", type:"date"},
              ].map((field) => (
                <div key={field.name}>
                  <label style={{fontSize:"13px", fontWeight:"700", color:"#374151", display:"block", marginBottom:"6px"}}>{field.label}</label>
                  <input name={field.name} value={form[field.name]} onChange={handleChange} placeholder={field.placeholder} type={field.type}
                    style={{width:"100%", padding:"12px", borderRadius:"10px", border:"1.5px solid #e2e8f0", background:"#f8fafc", color:"#0f172a", fontSize:"14px", boxSizing:"border-box", outline:"none"}} />
                </div>
              ))}
              {plan.title === "Mobile Device" && (
                <div style={{background:"#fffbeb", border:"1px solid #fbbf24", borderRadius:"10px", padding:"12px 16px", fontSize:"13px", color:"#92400e"}}>
                  📸 <strong>Inspection Required:</strong> After purchase, our team will contact you within 24 hours to conduct a quick phone inspection via video call before coverage begins.
                </div>
              )}
              {plan.title === "Livestock Insurance" && (
                <div style={{background:"#f0fdf4", border:"1px solid #86efac", borderRadius:"10px", padding:"12px 16px", fontSize:"13px", color:"#166534"}}>
                  📸 <strong>Photo Required:</strong> Please have a clear photo of your animal ready. Our team will verify it within 24 hours before coverage begins.
                </div>
              )}
              {plan.title === "Intern Insurance" && (
                <div style={{background:"#eff6ff", border:"1px solid #93c5fd", borderRadius:"10px", padding:"12px 16px", fontSize:"13px", color:"#1e40af"}}>
                  🏢 <strong>Company Purchase:</strong> Enter company details below. Certificates will be issued to both the company and each intern. Contact us for bulk pricing.
                </div>
              )}
            </div>
            <button onClick={() => setSubmitted(true)}
              style={{width:"100%", background:"linear-gradient(135deg, #0d9488, #0891b2)", color:"#fff", border:"none", borderRadius:"12px", padding:"14px", fontWeight:"700", fontSize:"16px", cursor:"pointer", marginTop:"20px", boxShadow:"0 4px 16px rgba(13,148,136,0.3)"}}>
              Confirm Purchase 🛡️
            </button>
          </>
        ) : (
          <div style={{textAlign:"center", padding:"20px 0"}}>
            <div style={{fontSize:"72px", marginBottom:"16px"}}>🎉</div>
            <h2 style={{fontSize:"26px", fontWeight:"900", color:"#0f172a", marginBottom:"8px"}}>You're Covered!</h2>
            <p style={{color:"#64748b", fontSize:"15px", marginBottom:"8px"}}>Your <strong style={{color:"#0d9488"}}>{plan.title}</strong> is confirmed.</p>
            <p style={{color:"#64748b", fontSize:"14px", marginBottom:"4px"}}>Underwritten by <strong>Himalayan Life Insurance</strong></p>
            <p style={{color:"#64748b", fontSize:"14px", marginBottom:"28px"}}>Confirmation sent to <strong>{form.email}</strong></p>
            <button onClick={onClose} style={{background:"linear-gradient(135deg, #0d9488, #0891b2)", color:"#fff", border:"none", borderRadius:"12px", padding:"14px 40px", fontWeight:"700", fontSize:"15px", cursor:"pointer"}}>Done ✓</button>
          </div>
        )}
      </div>
    </div>
  );
}

function PlansSection() {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <section id="plans" style={{padding:"80px 48px", background:"#f0fdfa"}}>
      <div style={{textAlign:"center", marginBottom:"48px"}}>
        <h2 style={{fontSize:"40px", fontWeight:"900", color:"#0f172a", marginBottom:"12px"}}>Our <span className="gradient-text">Plans</span></h2>
        <p style={{fontSize:"16px", color:"#64748b", marginBottom:"8px"}}>Simple, affordable insurance for every Nepali</p>
        <p style={{fontSize:"14px", color:"#0d9488", fontWeight:"700"}}>🤝 All plans underwritten by Himalayan Life Insurance · Coverage up to 100x your premium</p>
      </div>

      <div style={{display:"flex", gap:"28px", justifyContent:"center", flexWrap:"wrap"}}>
        {plans.map((plan, index) => (
          <div key={index}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
            style={{background:"#fff", border: hoveredIndex === index ? "2px solid #0d9488" : "2px solid #e2e8f0", borderRadius:"20px", padding:"32px", width:"290px", position:"relative", transition:"all 0.3s", transform: hoveredIndex === index ? "translateY(-8px)" : "translateY(0)", boxShadow: hoveredIndex === index ? "0 20px 48px rgba(13,148,136,0.15)" : "0 4px 16px rgba(0,0,0,0.04)", cursor:"pointer"}}>
            {plan.tag && (
              <span style={{position:"absolute", top:"16px", right:"16px", background:plan.tagColor, color:"#fff", fontSize:"11px", fontWeight:"700", padding:"4px 10px", borderRadius:"999px"}}>{plan.tag}</span>
            )}
            <div style={{fontSize:"44px", marginBottom:"16px", transition:"transform 0.3s", transform: hoveredIndex === index ? "scale(1.1)" : "scale(1)"}}>{plan.icon}</div>
            <h3 style={{fontSize:"18px", fontWeight:"800", color:"#0f172a", marginBottom:"8px"}}>{plan.title}</h3>
            <p style={{fontSize:"13px", color:"#64748b", marginBottom:"16px", lineHeight:"1.7"}}>{plan.description}</p>
            <div style={{marginBottom:"16px"}}>
              {plan.covers.slice(0,3).map((c, i) => (
                <div key={i} style={{fontSize:"12px", color:"#0f172a", marginBottom:"4px"}}>{c}</div>
              ))}
            </div>
            <div style={{marginBottom:"20px", paddingTop:"12px", borderTop:"1px solid #f1f5f9"}}>
              <span style={{fontSize:"26px", fontWeight:"900", color:"#0d9488"}}>{plan.price}</span>
              <span style={{fontSize:"13px", color:"#64748b"}}>{plan.period}</span>
            </div>
            <button onClick={() => setSelectedPlan(plan)}
              style={{width:"100%", background: hoveredIndex === index ? "linear-gradient(135deg, #0d9488, #0891b2)" : "#f0fdfa", color: hoveredIndex === index ? "#fff" : "#0d9488", border:"2px solid #0d9488", borderRadius:"10px", padding:"12px", fontWeight:"700", fontSize:"14px", cursor:"pointer", transition:"all 0.3s"}}>
              Buy Now →
            </button>
          </div>
        ))}
      </div>

      {selectedPlan && <BuyModal plan={selectedPlan} onClose={() => setSelectedPlan(null)} />}
    </section>
  );
}

export default PlansSection;